import { ESP } from "../tema";
import { ESTILO_CAMPO, Rotulo } from "./Campo";

// Mantido pelo nome antigo, que muita tela usa. O estilo agora vem de um
// lugar só, para o campo desta tela ser igual ao da tela do lado.
export default function Input({ label, value, onChange, type = "text", placeholder = "", style = {}, onKeyDown }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: ESP.xs, ...style }}>
      {label && <Rotulo>{label}</Rotulo>}
      <input
        type={type} value={value} onChange={e => onChange(e.target.value)}
        placeholder={placeholder} onKeyDown={onKeyDown}
        style={ESTILO_CAMPO}
      />
    </div>
  );
}
